var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1900_23125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06742 3.9118C1.28191 4.9338 0.689609 6.11173 0.344727 7.39137H5.54699L2.06742 3.9118Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6553 7.39134C19.3104 6.11173 18.7181 4.9338 17.9326 3.9118L14.4531 7.39134H19.6553Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.344727 12.6088C0.689648 13.8884 1.28195 15.0663 2.06742 16.0883L5.54688 12.6088H0.344727Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0889 2.06722C15.0669 1.28171 13.889 0.689404 12.6094 0.344482V5.54671L16.0889 2.06722Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91211 17.9328C4.9341 18.7183 6.11203 19.3106 7.39164 19.6555V14.4533L3.91211 17.9328Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3916 0.344482C6.11199 0.689404 4.93406 1.28171 3.91211 2.06718L7.3916 5.54667V0.344482Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6094 19.6555C13.889 19.3106 15.0669 18.7183 16.0889 17.9328L12.6094 14.4533V19.6555Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4531 12.6088L17.9326 16.0883C18.7181 15.0663 19.3104 13.8884 19.6553 12.6088H14.4531Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9154 8.69566H11.3044H11.3044V0.0846484C10.8774 0.0290625 10.4421 0 10 0C9.55785 0 9.12262 0.0290625 8.69566 0.0846484V8.69559V8.69563H0.0846484C0.0290625 9.12262 0 9.55793 0 10C0 10.4421 0.0290625 10.8774 0.0846484 11.3043H8.69559H8.69563V19.9154C9.12262 19.9709 9.55785 20 10 20C10.4421 20 10.8774 19.971 11.3043 19.9154V11.3044V11.3044H19.9154C19.9709 10.8774 20 10.4421 20 10C20 9.55793 19.9709 9.12262 19.9154 8.69566Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6084 12.6087L17.0707 17.0711C17.276 16.8659 17.4718 16.6514 17.6586 16.4291L13.8382 12.6087H12.6084V12.6087Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39109 12.6088H7.39102L2.92871 17.0711C3.13387 17.2763 3.34836 17.4721 3.5707 17.6589L7.39109 13.8384V12.6088Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39098 7.39135V7.39128L2.92863 2.92889C2.7234 3.13405 2.52762 3.34854 2.34082 3.57089L6.16125 7.39132H7.39098V7.39135Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6084 7.39138L17.0708 2.92896C16.8656 2.72373 16.6511 2.52794 16.4288 2.34119L12.6084 6.16162V7.39138Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1900_23125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.b806bdb21ce73f01f1a633988d4531ee.svg";
export { ForwardRef as ReactComponent };